<template>
  <div id="admin-markets">
    <v-card class="px-5 py-2 mt-4 mb-5 elevation-0">
      <v-row>
        <v-col cols="12" md="4">
          <div class="items-flex flex-end">
            <v-text-field
              v-model="filters.ticker"
              label="Ticker"
              :disabled="loading"
              hide-details
              clearable
              @keydown.enter="updateFilters"
            />
            <v-btn class="ml-5" color="primary" small :loading="loading" @click="updateFilters">
              Buscar
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card id="admin-markets" class="px-5 py-2 mt-5 mb-5 elevation-0">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        sort-by="ticker"
        :sort-desc="false"
        class="admin-markets-table elevation-0 mt-2"
        mobile-breakpoint="0"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': defaultPaginationItemsPerPageOptions,
        }"
        :items-per-page="20"
        dense
        @update:options="loadItems"
      >
        <template v-slot:item.eod.status="{ item }">
          <span v-if="item.eod && item.eod.status === 'pending'">
            <v-icon>mdi-alarm-check</v-icon>
          </span>
          <span v-else-if="item.eod && item.eod.status === 'errored'">
            <v-icon color="softRed">mdi-close-circle</v-icon>
          </span>
          <span v-else-if="item.eod && item.eod.status === 'updated'">
            <v-icon color="softGreen">mdi-check-circle</v-icon>
          </span>
          <span v-if="item.disableEodUpdate" class="ml-2">
            <b>(disabled)</b>
          </span>
        </template>

        <template v-slot:item.intraDay.status="{ item }">
          <span v-if="item.eod && item.intraDay.status === 'pending'">
            <v-icon>mdi-alarm-check</v-icon>
          </span>
          <span v-else-if="item.eod && item.intraDay.status === 'errored'">
            <v-icon color="softRed">mdi-close-circle</v-icon>
          </span>
          <span v-else-if="item.eod && item.intraDay.status === 'updated'">
            <v-icon color="softGreen">mdi-check-circle</v-icon>
          </span>
          <span v-if="item.disableIntraDayUpdate" class="ml-2">
            <b>(disabled)</b>
          </span>
        </template>

        <template v-slot:item.marketPrice="{ item }">
          <PositionMarketPrice
            type="watch"
            :position="{ ticker: item.ticker, currency: item.currency, market: item }"
          />
        </template>

        <template v-slot:item.actions="{ item }">
          <div>
            <a @click="setPending(item)">Set pending</a>
            <a class="ml-3" @click="enableDisableEodUpdate(item)">On/off eod</a>
            <a class="ml-3" @click="enableDisableIntraDayUpdate(item)">On/off intraday</a>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { adminGetMarkets, adminUpdateMarket, adminSetMarketAsPending } from '@/lib/api.js'
import tableMixin from '@/views/components/core/tableMixin.js'
import PositionMarketPrice from '@/views/components/common/positions/PositionMarketPrice'

export default {
  components: { PositionMarketPrice },
  mixins: [tableMixin],
  data: () => ({
    filters: {},
  }),
  computed: {
    defaultHeaders() {
      return [
        {
          text: 'ticker',
          value: 'ticker',
        },
        {
          text: 'type',
          value: 'type',
        },
        {
          text: 'country',
          value: 'country',
        },
        {
          text: 'exchange',
          value: 'exchange',
        },
        {
          text: 'currency',
          value: 'currency',
        },
        {
          text: 'eod.status',
          value: 'eod.status',
          sortable: false,
        },
        {
          text: 'intraDay.status',
          value: 'intraDay.status',
          sortable: false,
        },
        {
          text: 'marketPrice',
          value: 'marketPrice',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
        },
      ]
    },
  },
  methods: {
    async loadItems() {
      this.loading = true
      try {
        const filter = JSON.parse(JSON.stringify(this.filters))
        if (!filter.ticker || filter.ticker === '') delete filter.ticker

        const { page, limit, sort } = this.getTablePaginationOptions(this.options)
        const response = await adminGetMarkets({ filter, page, limit, sort })
        this.setTablePaginatedResponse(response)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
    updateFilters() {
      this.setFirstPage()
      this.loadItems()
    },
    async setPending(item) {
      this.loading = true

      try {
        await adminSetMarketAsPending(item._id)

        this.loadItems()
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }

      this.loading = false
    },
    async enableDisableEodUpdate(item) {
      this.loading = true

      try {
        const data = {
          disableEodUpdate: !item.disableEodUpdate,
        }
        await adminUpdateMarket(item._id, data)

        this.loadItems()
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }

      this.loading = false
    },
    async enableDisableIntraDayUpdate(item) {
      this.loading = true

      try {
        const data = {
          disableIntraDayUpdate: !item.disableIntraDayUpdate,
        }
        await adminUpdateMarket(item._id, data)

        this.loadItems()
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss">
#admin-markets {
  .items-flex {
    display: flex;
    &.flex-end {
      align-items: flex-end;
    }
  }
}
</style>
